const FUNDING_ROW_ID_MIME = 'application/x-timeclerk-funding-id';

function fundingRowDragHandleDirective() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      const getRow = () => scope.$eval(attrs.fundingRowDragHandle);

      element.attr('draggable', 'true');

      element.on('dragstart', (event) => {
        const row = getRow();

        if (!scope.$ctrl.canManageFundingDetails() || !row) {
          event.preventDefault();
          return;
        }

        event.originalEvent.dataTransfer.setData(FUNDING_ROW_ID_MIME, String(row.id));
        event.originalEvent.dataTransfer.effectAllowed = 'move';
        element.closest('tr').addClass('funding-row-dragging');
      });

      element.on('dragend', () => {
        element.closest('tr').removeClass('funding-row-dragging');
      });
    }
  };
}

function fundingRowDropDirective() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      const getRow = () => scope.$eval(attrs.fundingRowDrop);

      element.on('dragover', (event) => {
        if (!scope.$ctrl.canManageFundingDetails()) {
          return;
        }

        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'move';
      });

      element.on('drop', (event) => {
        if (!scope.$ctrl.canManageFundingDetails()) {
          return;
        }

        event.preventDefault();

        const targetRow = getRow();
        const draggedId = parseInt(event.originalEvent.dataTransfer.getData(FUNDING_ROW_ID_MIME), 10);

        if (!targetRow || !draggedId) {
          return;
        }

        scope.$ctrl.onFundingRowDrop(draggedId, targetRow.id);
        scope.$applyAsync();
      });
    }
  };
}

export { fundingRowDragHandleDirective, fundingRowDropDirective };



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/funding-row-drag.directive.js